const electronUserAgentRegex = /(Electron)\/([0-9]{1,}[.0-9]{0,})/;

module.exports = (userAgent) => {
  const matches = userAgent.match(electronUserAgentRegex);

  return matches && parseFloat(matches[2]);
};
